
























import { Mixins, Component, Watch, Prop } from 'vue-property-decorator'
import * as d3 from 'd3'
import { Options } from '../../@types/Slide'
import Canvas from '../../mixins/Canvas.vue'
import Grid from '../../mixins/Grid.vue'
import WrappedText from '../../mixins/WrappedText.vue'

@Component
export default class BubbleArea extends Mixins(Canvas, Grid, WrappedText) {
  /**
   * Default options.
   */
  public readonly defaultChartOptions: any = {
    radius: 10,
    backgroundColor: 'gray-800'
  }

  /**
   * Get labels.
   */
  get labels() {
    return this.__data.labels
  }

  /**
   * Collision method.
   */
  get collide() {
    return d3.forceCollide().radius(this.__options.radius * 1.2)
  }

  /**
   * Charge method.
   */
  get charge() {
    return d3.forceManyBody().strength(1)
  }

  /**
   * Get X force.
   */
  get xForce() {
    return d3
      .forceX()
      .strength(0.05)
      .x(d => d.targetX)
  }

  /**
   * Get Y force.
   */
  get yForce() {
    return d3
      .forceY()
      .strength(0.05)
      .y(d => d.targetY)
  }

  /**
   * Get nodes.
   */
  get nodes() {
    return this.__data.datasets
      .map((dataset, datasetIndex) => {
        return (dataset.data as [])
          .filter((value, dataIndex) => this.__data.labels[dataIndex])
          .map((value, dataIndex) => {
            const datasetGrid = this.datasetsGrid[datasetIndex]
            const dataGrid = this.dataGrids[datasetIndex].find(
              ({ label }) => label === value
            )
            return {
              name: this.__data.labels[dataIndex],
              value: value,
              x: datasetGrid.x,
              y: datasetGrid.y,
              targetX: dataGrid.x,
              targetY: dataGrid.y,
              datasetIndex: datasetIndex
            }
          })
      })
      .flat()
  }

  /**
   * Draw text from grid.
   */
  public drawText(grid: any, hPadding: number = 0, wPadding: number = 0): any {
    grid.forEach(node => {
      if (node.label) {
        this.context.textAlign = 'center'
        this.context.textBaseline = 'middle'
        this.context.font = '1rem Poppins'
        this.wrapText(
          this.context,
          node.label,
          node.x,
          node.y2,
          node.width,
          '1rem'
        )
      }
    })

    return grid
  }

  /**
   * Render the canvas.
   */
  public renderCanvas() {
    d3.forceSimulation(this.nodes)
      .force('charge', this.charge)
      .force('collide', this.collide)
      .force('x', this.xForce)
      .force('y', this.yForce)
      .on('tick', this.ticked)
  }

  /**
   * Get fill color for the given feature.
   */
  public getFillColor(name: string, datasetIndex: number): string {
    if (Array.isArray(this.__data.datasets[datasetIndex].backgroundColor)) {
      return this.__data.datasets[datasetIndex].backgroundColor[
        this.__data.labels.indexOf(name)
      ]
    }

    return this.__options.backgroundColor
  }

  /**
   * On tick.
   */
  public ticked() {
    this.reset()
    this.drawText(
      this.datasetsGrid,
      (this.height / this.dataGrids.length) * 0.2
    )
    this.dataGrids.forEach(d => this.drawText(d))
    this.context.save()
    this.nodes.forEach(d => {
      this.context.fillStyle = this.getFillColor(d.name, d.datasetIndex)
      this.context.beginPath()
      this.context.arc(d.x, d.y, this.__options.radius, 0, 2 * Math.PI)
      this.context.fill()
    })
    this.context.restore()
  }
}
